module.exports = __webpack_public_path__ + "img/step2-b.c26dc9f1.png";